/**
 * All of the constants that dynamic behaviour is based upon 
 */
export const constants = {
	
	countries : {
		"Canada"          : "527fcb26-4865-ef11-96f6-005056819f26"
		, "United States" : "da80cb26-4865-ef11-96f6-005056819f26"
		, "Mexico"        : "2080cb26-4865-ef11-96f6-005056819f26"
	}
	
	//the following is/are hard-coded standard code table(s) that aren't going to change, so GCCASE doesn't need to send us this:
	, yesNo : {
		"en" : [
			{"value":"true", "label":"Yes"}
			,{"value":"false", "label":"No"}
		]
		, "fr" : [
			{"value":"true", "label":"Oui"}
			,{"value":"false", "label":"Non"}
		]
	}
	//the following is/are the SiteMinder -> GCCASE SCT GUID mappings.  So the value should be duplicated across the English and French versions of the same concept.
	, languagePreferenceGUID : {
		"English"    : "19d186a4-6ae1-ee11-96eb-005056817227"
		, "French"   : "2ec061ab-6ae1-ee11-96eb-005056817227"
		, "Anglais"  : "19d186a4-6ae1-ee11-96eb-005056817227"
		, "Français" : "2ec061ab-6ae1-ee11-96eb-005056817227"
	}
	, languagePreferenceGUIDtoLang : {
		 "19d186a4-6ae1-ee11-96eb-005056817227" : "en"
		,"2ec061ab-6ae1-ee11-96eb-005056817227" : "fr"
	}
	//the following is/are some constants used by the code only that aren't going to change
	, maxUploadLimitPerSubmission : 500
	, maxConcurrentUploadRequests : 2
  
  , registrantInfoFirm : "d924f3d1-c1c5-ee11-96e7-005056817227"

	, roles : {
		"Counsel":"da90eb75-e7c5-ee11-96ea-005056819f26",
    "Union":"dc90eb75-e7c5-ee11-96ea-005056819f26",
    "Others":"de90eb75-e7c5-ee11-96ea-005056819f26"
	}

	, typeOfSubmissions : {
		"Other":"04bd4332-9fea-ee11-96ea-0050568199d1"
		, "Response to Disclosure-Related Deficiency Notice":"f8bc4332-9fea-ee11-96ea-0050568199d1"
	}
	
	, otherSubmissionTypes : {
	     "dumpingOrSubsidy"             : "1b045380-79e8-ee11-96ec-00505681fc69"
	   , "normalValueRepresentation"    : "184c0b8e-79e8-ee11-96ec-00505681fc69" 
	   , "disclosureUndertaking"        : "8b6ef096-79e8-ee11-96ec-00505681fc69" 
	   , "requestForDisclosure"         : "05047ea1-79e8-ee11-96ec-00505681fc69" 
	   , "normalValueUpdate"            : "efa5e8d3-dca8-ef11-96f5-00505681d99b" 
	   , "limitedDisclosureRequest"     : "0e9bd82b-dda8-ef11-96f5-00505681d99b" 
	}

	, countryGUIDToAlpha2 : {
        "067fcb26-4865-ef11-96f6-005056819f26": "AF",
        "087fcb26-4865-ef11-96f6-005056819f26": "AX",
        "0a7fcb26-4865-ef11-96f6-005056819f26": "AL",
        "0c7fcb26-4865-ef11-96f6-005056819f26": "DZ",
        "0e7fcb26-4865-ef11-96f6-005056819f26": "AS",
        "107fcb26-4865-ef11-96f6-005056819f26": "AD",
        "127fcb26-4865-ef11-96f6-005056819f26": "AO",
        "147fcb26-4865-ef11-96f6-005056819f26": "AI",
        "167fcb26-4865-ef11-96f6-005056819f26": "AQ",
        "187fcb26-4865-ef11-96f6-005056819f26": "AG",
        "1a7fcb26-4865-ef11-96f6-005056819f26": "AR",
        "1c7fcb26-4865-ef11-96f6-005056819f26": "AM",
        "1e7fcb26-4865-ef11-96f6-005056819f26": "AW",
        "207fcb26-4865-ef11-96f6-005056819f26": "AU",
        "227fcb26-4865-ef11-96f6-005056819f26": "AT",
        "247fcb26-4865-ef11-96f6-005056819f26": "AZ",
        "267fcb26-4865-ef11-96f6-005056819f26": "BS",
        "287fcb26-4865-ef11-96f6-005056819f26": "BH",
        "2a7fcb26-4865-ef11-96f6-005056819f26": "BD",
        "2c7fcb26-4865-ef11-96f6-005056819f26": "BB",
        "2e7fcb26-4865-ef11-96f6-005056819f26": "BY",
        "307fcb26-4865-ef11-96f6-005056819f26": "BE",
        "327fcb26-4865-ef11-96f6-005056819f26": "BZ",
        "347fcb26-4865-ef11-96f6-005056819f26": "BJ",
        "367fcb26-4865-ef11-96f6-005056819f26": "BM",
        "387fcb26-4865-ef11-96f6-005056819f26": "BT",
        "3a7fcb26-4865-ef11-96f6-005056819f26": "BO",
        "3c7fcb26-4865-ef11-96f6-005056819f26": "BA",
        "3e7fcb26-4865-ef11-96f6-005056819f26": "BW",
        "407fcb26-4865-ef11-96f6-005056819f26": "BV",
        "427fcb26-4865-ef11-96f6-005056819f26": "BR",
        "447fcb26-4865-ef11-96f6-005056819f26": "IO",
        "467fcb26-4865-ef11-96f6-005056819f26": "BN",
        "487fcb26-4865-ef11-96f6-005056819f26": "BG",
        "4a7fcb26-4865-ef11-96f6-005056819f26": "BF",
        "4c7fcb26-4865-ef11-96f6-005056819f26": "BI",
        "4e7fcb26-4865-ef11-96f6-005056819f26": "KH",
        "507fcb26-4865-ef11-96f6-005056819f26": "CM",
        "527fcb26-4865-ef11-96f6-005056819f26": "CA",
        "547fcb26-4865-ef11-96f6-005056819f26": "CV",
        "567fcb26-4865-ef11-96f6-005056819f26": "KY",
        "587fcb26-4865-ef11-96f6-005056819f26": "CF",
        "5a7fcb26-4865-ef11-96f6-005056819f26": "TD",
        "5c7fcb26-4865-ef11-96f6-005056819f26": "CL",
        "5e7fcb26-4865-ef11-96f6-005056819f26": "CN",
        "607fcb26-4865-ef11-96f6-005056819f26": "CX",
        "627fcb26-4865-ef11-96f6-005056819f26": "CC",
        "647fcb26-4865-ef11-96f6-005056819f26": "CO",
        "667fcb26-4865-ef11-96f6-005056819f26": "KM",
        "687fcb26-4865-ef11-96f6-005056819f26": "CG",
        "6a7fcb26-4865-ef11-96f6-005056819f26": "CK",
        "6c7fcb26-4865-ef11-96f6-005056819f26": "CR",
        "6e7fcb26-4865-ef11-96f6-005056819f26": "CI",
        "707fcb26-4865-ef11-96f6-005056819f26": "HR",
        "727fcb26-4865-ef11-96f6-005056819f26": "CU",
        "747fcb26-4865-ef11-96f6-005056819f26": "CY",
        "767fcb26-4865-ef11-96f6-005056819f26": "CZ",
        "787fcb26-4865-ef11-96f6-005056819f26": "CD",
        "7a7fcb26-4865-ef11-96f6-005056819f26": "DK",
        "7c7fcb26-4865-ef11-96f6-005056819f26": "DJ",
        "7e7fcb26-4865-ef11-96f6-005056819f26": "DM",
        "807fcb26-4865-ef11-96f6-005056819f26": "DO",
        "827fcb26-4865-ef11-96f6-005056819f26": "TL",
        "847fcb26-4865-ef11-96f6-005056819f26": "EC",
        "867fcb26-4865-ef11-96f6-005056819f26": "EG",
        "887fcb26-4865-ef11-96f6-005056819f26": "SV",
        "8a7fcb26-4865-ef11-96f6-005056819f26": "GB",
        "8c7fcb26-4865-ef11-96f6-005056819f26": "GQ",
        "8e7fcb26-4865-ef11-96f6-005056819f26": "ER",
        "907fcb26-4865-ef11-96f6-005056819f26": "EE",
        "927fcb26-4865-ef11-96f6-005056819f26": "ET",
        "947fcb26-4865-ef11-96f6-005056819f26": "FO",
        "967fcb26-4865-ef11-96f6-005056819f26": "FK",
        "987fcb26-4865-ef11-96f6-005056819f26": "FJ",
        "9a7fcb26-4865-ef11-96f6-005056819f26": "FI",
        "9c7fcb26-4865-ef11-96f6-005056819f26": "FR",
        "9e7fcb26-4865-ef11-96f6-005056819f26": "GF",
        "a07fcb26-4865-ef11-96f6-005056819f26": "PF",
        "a27fcb26-4865-ef11-96f6-005056819f26": "TF",
        "a47fcb26-4865-ef11-96f6-005056819f26": "GA",
        "a67fcb26-4865-ef11-96f6-005056819f26": "GM",
        "a87fcb26-4865-ef11-96f6-005056819f26": "GE",
        "aa7fcb26-4865-ef11-96f6-005056819f26": "DE",
        "ac7fcb26-4865-ef11-96f6-005056819f26": "GH",
        "ae7fcb26-4865-ef11-96f6-005056819f26": "GI",
        "b07fcb26-4865-ef11-96f6-005056819f26": "GR",
        "b27fcb26-4865-ef11-96f6-005056819f26": "GL",
        "b47fcb26-4865-ef11-96f6-005056819f26": "GD",
        "b67fcb26-4865-ef11-96f6-005056819f26": "GP",
        "b87fcb26-4865-ef11-96f6-005056819f26": "GU",
        "ba7fcb26-4865-ef11-96f6-005056819f26": "GT",
        "bc7fcb26-4865-ef11-96f6-005056819f26": "GG",
        "be7fcb26-4865-ef11-96f6-005056819f26": "GW",
        "c07fcb26-4865-ef11-96f6-005056819f26": "GN",
        "c27fcb26-4865-ef11-96f6-005056819f26": "GY",
        "c47fcb26-4865-ef11-96f6-005056819f26": "HT",
        "c67fcb26-4865-ef11-96f6-005056819f26": "HM",
        "c87fcb26-4865-ef11-96f6-005056819f26": "HN",
        "ca7fcb26-4865-ef11-96f6-005056819f26": "HK",
        "cc7fcb26-4865-ef11-96f6-005056819f26": "HU",
        "ce7fcb26-4865-ef11-96f6-005056819f26": "IS",
        "d07fcb26-4865-ef11-96f6-005056819f26": "IN",
        "d27fcb26-4865-ef11-96f6-005056819f26": "ID",
        "d47fcb26-4865-ef11-96f6-005056819f26": "IR",
        "d67fcb26-4865-ef11-96f6-005056819f26": "IQ",
        "d87fcb26-4865-ef11-96f6-005056819f26": "IE",
        "da7fcb26-4865-ef11-96f6-005056819f26": "IM",
        "dc7fcb26-4865-ef11-96f6-005056819f26": "IL",
        "de7fcb26-4865-ef11-96f6-005056819f26": "IT",
        "e07fcb26-4865-ef11-96f6-005056819f26": "JM",
        "e27fcb26-4865-ef11-96f6-005056819f26": "JP",
        "e47fcb26-4865-ef11-96f6-005056819f26": "JE",
        "e67fcb26-4865-ef11-96f6-005056819f26": "JO",
        "e87fcb26-4865-ef11-96f6-005056819f26": "KZ",
        "ea7fcb26-4865-ef11-96f6-005056819f26": "KE",
        "ec7fcb26-4865-ef11-96f6-005056819f26": "KI",
        "ee7fcb26-4865-ef11-96f6-005056819f26": "KP",
        "f07fcb26-4865-ef11-96f6-005056819f26": "KW",
        "f27fcb26-4865-ef11-96f6-005056819f26": "KG",
        "f47fcb26-4865-ef11-96f6-005056819f26": "LA",
        "f67fcb26-4865-ef11-96f6-005056819f26": "LV",
        "f87fcb26-4865-ef11-96f6-005056819f26": "LB",
        "fa7fcb26-4865-ef11-96f6-005056819f26": "LS",
        "fc7fcb26-4865-ef11-96f6-005056819f26": "LR",
        "fe7fcb26-4865-ef11-96f6-005056819f26": "LY",
        "0080cb26-4865-ef11-96f6-005056819f26": "LI",
        "0280cb26-4865-ef11-96f6-005056819f26": "LT",
        "0480cb26-4865-ef11-96f6-005056819f26": "LU",
        "0680cb26-4865-ef11-96f6-005056819f26": "MO",
        "0880cb26-4865-ef11-96f6-005056819f26": "MK",
        "0a80cb26-4865-ef11-96f6-005056819f26": "MG",
        "0c80cb26-4865-ef11-96f6-005056819f26": "MW",
        "0e80cb26-4865-ef11-96f6-005056819f26": "MY",
        "1080cb26-4865-ef11-96f6-005056819f26": "MV",
        "1280cb26-4865-ef11-96f6-005056819f26": "ML",
        "1480cb26-4865-ef11-96f6-005056819f26": "MT",
        "1680cb26-4865-ef11-96f6-005056819f26": "MH",
        "1880cb26-4865-ef11-96f6-005056819f26": "MQ",
        "1a80cb26-4865-ef11-96f6-005056819f26": "MR",
        "1c80cb26-4865-ef11-96f6-005056819f26": "MU",
        "1e80cb26-4865-ef11-96f6-005056819f26": "YT",
        "2080cb26-4865-ef11-96f6-005056819f26": "MX",
        "2280cb26-4865-ef11-96f6-005056819f26": "FM",
        "2480cb26-4865-ef11-96f6-005056819f26": "MD",
        "2680cb26-4865-ef11-96f6-005056819f26": "MC",
        "2880cb26-4865-ef11-96f6-005056819f26": "MN",
        "2a80cb26-4865-ef11-96f6-005056819f26": "ME",
        "2c80cb26-4865-ef11-96f6-005056819f26": "MS",
        "2e80cb26-4865-ef11-96f6-005056819f26": "MA",
        "3080cb26-4865-ef11-96f6-005056819f26": "MZ",
        "3280cb26-4865-ef11-96f6-005056819f26": "MM",
        "3480cb26-4865-ef11-96f6-005056819f26": "NA",
        "3680cb26-4865-ef11-96f6-005056819f26": "NR",
        "3880cb26-4865-ef11-96f6-005056819f26": "NP",
        "3a80cb26-4865-ef11-96f6-005056819f26": "AN",
        "3c80cb26-4865-ef11-96f6-005056819f26": "NL",
        "3e80cb26-4865-ef11-96f6-005056819f26": "NT",
        "4080cb26-4865-ef11-96f6-005056819f26": "NC",
        "4280cb26-4865-ef11-96f6-005056819f26": "NZ",
        "4480cb26-4865-ef11-96f6-005056819f26": "NI",
        "4680cb26-4865-ef11-96f6-005056819f26": "NE",
        "4880cb26-4865-ef11-96f6-005056819f26": "NG",
        "4a80cb26-4865-ef11-96f6-005056819f26": "NU",
        "4c80cb26-4865-ef11-96f6-005056819f26": "NF",
        "4e80cb26-4865-ef11-96f6-005056819f26": "MP",
        "5080cb26-4865-ef11-96f6-005056819f26": "NO",
        "5280cb26-4865-ef11-96f6-005056819f26": "OM",
        "5480cb26-4865-ef11-96f6-005056819f26": "ZZ",
        "5680cb26-4865-ef11-96f6-005056819f26": "PK",
        "5880cb26-4865-ef11-96f6-005056819f26": "PW",
        "5a80cb26-4865-ef11-96f6-005056819f26": "PS",
        "5c80cb26-4865-ef11-96f6-005056819f26": "PA",
        "5e80cb26-4865-ef11-96f6-005056819f26": "PG",
        "6080cb26-4865-ef11-96f6-005056819f26": "PY",
        "6280cb26-4865-ef11-96f6-005056819f26": "PE",
        "6480cb26-4865-ef11-96f6-005056819f26": "PH",
        "6680cb26-4865-ef11-96f6-005056819f26": "PN",
        "6880cb26-4865-ef11-96f6-005056819f26": "PL",
        "6a80cb26-4865-ef11-96f6-005056819f26": "PT",
        "6c80cb26-4865-ef11-96f6-005056819f26": "PR",
        "6e80cb26-4865-ef11-96f6-005056819f26": "QA",
        "7080cb26-4865-ef11-96f6-005056819f26": "RE",
        "7280cb26-4865-ef11-96f6-005056819f26": "RO",
        "7480cb26-4865-ef11-96f6-005056819f26": "RU",
        "7680cb26-4865-ef11-96f6-005056819f26": "RW",
        "7880cb26-4865-ef11-96f6-005056819f26": "LC",
        "7a80cb26-4865-ef11-96f6-005056819f26": "WS",
        "7c80cb26-4865-ef11-96f6-005056819f26": "SM",
        "7e80cb26-4865-ef11-96f6-005056819f26": "ST",
        "8080cb26-4865-ef11-96f6-005056819f26": "SA",
        "8280cb26-4865-ef11-96f6-005056819f26": "GB",
        "8480cb26-4865-ef11-96f6-005056819f26": "SN",
        "8680cb26-4865-ef11-96f6-005056819f26": "RS",
        "8880cb26-4865-ef11-96f6-005056819f26": "SC",
        "8a80cb26-4865-ef11-96f6-005056819f26": "SL",
        "8c80cb26-4865-ef11-96f6-005056819f26": "SG",
        "8e80cb26-4865-ef11-96f6-005056819f26": "SK",
        "9080cb26-4865-ef11-96f6-005056819f26": "SI",
        "9280cb26-4865-ef11-96f6-005056819f26": "SB",
        "9480cb26-4865-ef11-96f6-005056819f26": "SO",
        "9680cb26-4865-ef11-96f6-005056819f26": "ZA",
        "9880cb26-4865-ef11-96f6-005056819f26": "GS",
        "9a80cb26-4865-ef11-96f6-005056819f26": "ES",
        "9c80cb26-4865-ef11-96f6-005056819f26": "LK",
        "9e80cb26-4865-ef11-96f6-005056819f26": "SH",
        "a080cb26-4865-ef11-96f6-005056819f26": "KN",
        "a280cb26-4865-ef11-96f6-005056819f26": "PM",
        "a480cb26-4865-ef11-96f6-005056819f26": "VC",
        "a680cb26-4865-ef11-96f6-005056819f26": "SD",
        "a880cb26-4865-ef11-96f6-005056819f26": "SR",
        "aa80cb26-4865-ef11-96f6-005056819f26": "SJ",
        "ac80cb26-4865-ef11-96f6-005056819f26": "SZ",
        "ae80cb26-4865-ef11-96f6-005056819f26": "SE",
        "b080cb26-4865-ef11-96f6-005056819f26": "CH",
        "b280cb26-4865-ef11-96f6-005056819f26": "SY",
        "b480cb26-4865-ef11-96f6-005056819f26": "TW",
        "b680cb26-4865-ef11-96f6-005056819f26": "TJ",
        "b880cb26-4865-ef11-96f6-005056819f26": "TZ",
        "ba80cb26-4865-ef11-96f6-005056819f26": "TH",
        "bc80cb26-4865-ef11-96f6-005056819f26": "TG",
        "be80cb26-4865-ef11-96f6-005056819f26": "TK",
        "c080cb26-4865-ef11-96f6-005056819f26": "TO",
        "c280cb26-4865-ef11-96f6-005056819f26": "TT",
        "c480cb26-4865-ef11-96f6-005056819f26": "TN",
        "c680cb26-4865-ef11-96f6-005056819f26": "TR",
        "c880cb26-4865-ef11-96f6-005056819f26": "TM",
        "ca80cb26-4865-ef11-96f6-005056819f26": "TC",
        "cc80cb26-4865-ef11-96f6-005056819f26": "TV",
        "ce80cb26-4865-ef11-96f6-005056819f26": "UG",
        "d080cb26-4865-ef11-96f6-005056819f26": "UA",
        "d280cb26-4865-ef11-96f6-005056819f26": "SU",
        "d480cb26-4865-ef11-96f6-005056819f26": "AE",
        "d680cb26-4865-ef11-96f6-005056819f26": "GB",
        "d880cb26-4865-ef11-96f6-005056819f26": "UM",
        "da80cb26-4865-ef11-96f6-005056819f26": "US",
        "dc80cb26-4865-ef11-96f6-005056819f26": "ZZ",
        "de80cb26-4865-ef11-96f6-005056819f26": "UY",
        "e080cb26-4865-ef11-96f6-005056819f26": "UZ",
        "e280cb26-4865-ef11-96f6-005056819f26": "VU",
        "e480cb26-4865-ef11-96f6-005056819f26": "VA",
        "e680cb26-4865-ef11-96f6-005056819f26": "VE",
        "e880cb26-4865-ef11-96f6-005056819f26": "VN",
        "ea80cb26-4865-ef11-96f6-005056819f26": "VG",
        "ec80cb26-4865-ef11-96f6-005056819f26": "VI",
        "ee80cb26-4865-ef11-96f6-005056819f26": "GB",
        "f080cb26-4865-ef11-96f6-005056819f26": "WF",
        "f280cb26-4865-ef11-96f6-005056819f26": "EH",
        "f480cb26-4865-ef11-96f6-005056819f26": "YE",
        "f680cb26-4865-ef11-96f6-005056819f26": "YU",
        "f880cb26-4865-ef11-96f6-005056819f26": "ZM",
        "fa80cb26-4865-ef11-96f6-005056819f26": "ZW"
    }
};